import React, { useState, useEffect } from 'react';
import './App.css';
import SplashScreen from './Pages/Splashscreen';
import All from './Pages/All';
import Watch from './Pages/Watch';
import Education from './Pages/education';
import Management from './Pages/management';
import ComingSoon from './Pages/comingsoon';
import Games from './Pages/games';
import { Routes, Route, useLocation, useNavigate, Navigate } from "react-router-dom";
import Navbar from './Components/Navbar';
import Login from "./Pages/Login";

// ── Protected Route — redirects to /login if not logged in ──
function ProtectedRoute({ user, children }) {
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  const [showSplash, setShowSplash] = useState(true);
  const [user, setUser]             = useState(null);
  const [userLoaded, setUserLoaded] = useState(false);
  const location                    = useLocation();
  const navigate                    = useNavigate();

  // Load user from storage on mount
  useEffect(() => {
    try {
      const saved = localStorage.getItem("athena_user");
      if (saved) setUser(JSON.parse(saved));
    } catch {}
    setUserLoaded(true); // mark done so we don't flash redirect before checking
  }, []);

  function handleLogin(userData) {
    setUser(userData);
    try { localStorage.setItem("athena_user", JSON.stringify(userData)); } catch {}
    navigate("/");
  }

  function handleLogout() {
    setUser(null);
    try { localStorage.removeItem("athena_user"); } catch {}
    navigate("/login");
  }

  const isWatchPage     = location.pathname.startsWith('/watch');
  const isEducationWeb  = location.pathname.startsWith('/education/web');
  const isManagementWeb = location.pathname.startsWith('/management/web');
  const isComingSoon    = location.pathname.startsWith('/management/coming-soon') || location.pathname.startsWith('/coming-soon');
  const isGamesPlay     = location.pathname.startsWith('/games/play');
  const isLoginPage     = location.pathname.startsWith('/login');

  const hideNavbar = isWatchPage || isEducationWeb || isManagementWeb || isComingSoon || isGamesPlay || isLoginPage;

  // Don't render anything until we've checked localStorage
  // BUT: always show splash first — don't wait for userLoaded
  if (showSplash) {
    return <SplashScreen onVideoEnd={() => setShowSplash(false)} />;
  }

  // After splash, wait for user check before rendering routes
  if (!userLoaded) return null;

  return (
    <>
      {!hideNavbar && (
        <Navbar user={user} onLogout={handleLogout} />
      )}

      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login onLogin={handleLogin} />} />

        {/* Protected routes — all require login */}
        <Route path="/" element={
          <ProtectedRoute user={user}><All user={user} /></ProtectedRoute>
        } />
        <Route path="/watch/:type/:id" element={
          <ProtectedRoute user={user}><Watch /></ProtectedRoute>
        } />
        <Route path="/education" element={
          <ProtectedRoute user={user}><Education user={user} /></ProtectedRoute>
        } />
        <Route path="/education/web" element={
          <ProtectedRoute user={user}><Education user={user} /></ProtectedRoute>
        } />
        <Route path="/management" element={
          <ProtectedRoute user={user}><Management user={user} /></ProtectedRoute>
        } />
        <Route path="/management/web" element={
          <ProtectedRoute user={user}><Management user={user} /></ProtectedRoute>
        } />
        <Route path="/management/coming-soon" element={
          <ProtectedRoute user={user}><ComingSoon /></ProtectedRoute>
        } />
        <Route path="/coming-soon" element={
          <ProtectedRoute user={user}><ComingSoon /></ProtectedRoute>
        } />
        <Route path="/games" element={
          <ProtectedRoute user={user}><Games user={user} /></ProtectedRoute>
        } />
        <Route path="/games/play" element={
          <ProtectedRoute user={user}><Games user={user} /></ProtectedRoute>
        } />

        {/* Fallback */}
        <Route path="*" element={<Navigate to={user ? "/" : "/login"} replace />} />
      </Routes>
    </>
  );
}

export default App;